import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { ApplicationInsights, Snippet } from '@microsoft/applicationinsights-web';
import { ReactPlugin, withAITracking  } from '@microsoft/applicationinsights-react-js';
import { _clientSettings } from '../../config/client-settings';

export const reactPlugin = new ReactPlugin();

const snippet: Snippet = {
    config: {
        instrumentationKey: _clientSettings.insights.instrumentationKey,
        extensions: [reactPlugin as any],
        extensionConfig: {
            [reactPlugin.identifier]: { history: null }
        }
    }    
};

let appInsights: ApplicationInsights = null;

export const InsightContext = React.createContext(null);

const { Provider } = InsightContext;
export const InsightProvider = (props) => {
    const history = useHistory();
    
    useEffect(() => {
        if (_clientSettings.insights && _clientSettings.insights.instrumentationKey){
            snippet.config.extensionConfig.ReactPlugin.history = history;
            appInsights = new ApplicationInsights(snippet);
            appInsights.loadAppInsights();
        }
    },[]);

    const trackEvent = (name, data) => {
        if (appInsights)
            appInsights.trackEvent({ name }, data);
    };

    const trackError = (error) => {
        if (appInsights)
            appInsights.trackException({ exception: error});
    };
    
    return (
        <Provider value={{
            trackEvent,
            trackError
        }}>
            {props.children}
        </Provider>
    );
}